import React from 'react';
import { IconProps } from '.';

const SvgContract = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m23.1 6.54-4.654-2.541-6.534 10.7-.392 3.051H9.333a1.023 1.023 0 0 1-.043-.044 4.856 4.856 0 0 1-.398-.536l-.025-.037c-.14-.206-.314-.463-.497-.667-.161-.18-.512-.534-1.022-.53-.63.004-.907.517-1.001.73-.085.19-.152.435-.2.613l-.03.109c-.043.148-.078.25-.109.319l-.014-.031a2.736 2.736 0 0 1-.122-.37c-.147-.543-.267-1.292-.377-1.982l-.07-.436c-.073-.447-.198-.908-.44-1.291-.257-.41-.65-.726-1.195-.822-.59-.104-1.076.128-1.414.433-.323.29-.545.67-.69.998-.63 1.413-.53 2.928 0 4.387l.257.705 1.41-.512-.257-.705c-.438-1.207-.47-2.303-.04-3.265.1-.224.216-.396.324-.493.09-.082.127-.075.149-.071h.001c.065.012.118.036.187.145.086.136.168.369.228.734l.063.396c.11.688.245 1.543.416 2.172.105.386.245.792.519 1.091.328.359.74.46 1.131.46.535 0 .904-.286 1.125-.608.179-.26.28-.566.344-.788l.108.158.006.009c.146.214.331.488.533.705.177.191.53.524 1.032.524h2.949l.057.036a1.5 1.5 0 0 0 1.641-.064l2.628-1.868L23.101 6.54ZM18.983 6l-5.623 9.208L13 18l2.377-1.69L21 7.102 18.982 6ZM7.179 17.394a.041.041 0 0 1-.009-.006l.009.006Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgContract;
